import * as React from 'react';
import ToggleButton from 'components/common/ToggleButton';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';
import styles from './ChangeDeliveryDialog.styles';
import { DataGrid } from 'devextreme-react';
import { createDataSource } from 'components/common/DataGridDevEx/DataGrid.hooks';
import { IContent } from './ChangeDeliveryDialog.properties';
import Selectors from '../Worksale.selectors';
import { useSites } from 'api/Worksale/worksale';
import { useSPContextSelector } from '../Worksale.context';
import { columns } from './ChangeDeliveryDialog.constants';

const Content = ({ defaultDelivery, classes, selected, setSelected, toogleChecked, setToogleChecked, handleOnOk }: IContent) => {
  const worksaleId = useSPContextSelector(Selectors.WorksaleId) || -1;
  const fetchLinesMutation = useSites();

  const dataGridInnerRef = React.useRef<DataGrid>();

  const fetch = React.useCallback(
    async (BatchPage, _BatchSize, _Sort) => {
      if (worksaleId !== -1) {
        try {
          const response = await fetchLinesMutation.mutateAsync({
            WorksaleID: worksaleId || -1,
            BatchPage,
            BatchSize: 100,
            CheckExactMatch: false,
            SearchText: ''
          });

          return response?.Data?.map(({Details}) => ({Name: Details?.Name, SiteCode: Details?.SiteCode, City: Details?.City})) ?? [];
        } catch (error) {
          console.error('Error fetching lines:', error);

          return null;
        }
      } else {
        return null;
      }
    },
    [worksaleId, dataGridInnerRef?.current]
  );

  const sitesDataSource = React.useMemo(
    () => createDataSource('SiteCode', { fetch }),
    [fetch]
  );

  return (
    <div className={classes.parentContainer}>
      <div className={classes.defaultDelivery}>Move all sales lines from <b>{defaultDelivery}</b> to a new delivery site.</div>
      <Paper className={classes.gridContainer}>
        <DynamicDataGrid
          dataGridClassName={classes.grid}
          columns={columns}
          allowHeaderFilting={false}
          allowUpdating={false}
          allowDelete={false}
          actionButtonsVisibility={false}
          gridProps={{
            dataSource: sitesDataSource,
            dataGridRef: dataGridInnerRef,
            selection: { mode: 'single' },
            onRowDblClick({ data }: any): void {
              setSelected(data.SiteCode);
              setToogleChecked(Boolean(data.SiteCode));
              handleOnOk();
            },
            onRowClick({ data }: any): void {
              setSelected(data.SiteCode);
              setToogleChecked(Boolean(data.SiteCode));
            }
          }}
        />
      </Paper>
      <ToggleButton
        checked={toogleChecked}
        disabled={defaultDelivery === selected}
        label={'Default Delivery'}
        onChange={(e) => {
          setToogleChecked(e.target.checked);
        }}
      />
    </div>
  );
};

export default withStyles(styles, { index: 1 })(Content);
